export const AUTH__USER_SAVE = 'AUTH__USER_SAVE';
export const AUTH__LOGOUT = 'AUTH__LOGOUT';
export const AUTH__STATE_TOGGLE = 'AUTH__STATE_TOGGLE';
